import { render, staticRenderFns } from "./confirmMessage.vue?vue&type=template&id=6b0e95b7&"
import script from "./confirmMessage.vue?vue&type=script&lang=js&"
export * from "./confirmMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports